import { waitForAnimation } from "../../utility";

export const NEW_ITEM_PK = 'NEW_ITEM_TEMP';

export const createNewSearchListItem = (primaryKey, obj = {}) => {
  return {
    ...obj,
    [primaryKey]: NEW_ITEM_PK
  };
}

export const addNewSearchListItem = (array, primaryKey, obj = {}) => {
  return [...array, createNewSearchListItem(primaryKey, obj)];
}

export const createNewSearchListItemFromComponent = (component, arrayKey, primaryKey, searchListRef) => {
  component[arrayKey] = addNewSearchListItem(component[arrayKey], primaryKey);
  waitForAnimation(() => {
    component.$refs[searchListRef].focusNewInput();
  });
}